import useInvoiceNotificationFeed from 'hooks/useInvoiceNotificationFeed'

// This file was supposed to be used for a more complex notification subscription component,
// but for now it simply wraps the useInvoiceNotificationFeed hook.
const NotificationSubscriber = ({ onNotification }) => {
  useInvoiceNotificationFeed({ onNotification })

  return null
}

export default NotificationSubscriber
